var map = {
	"./alfamart.png": 2072,
	"./alfamidi.png": 3648,
	"./atmbersama.png": 9802,
	"./bakmiGM.png": 2334,
	"./bca.png": 2762,
	"./bni.png": 6432,
	"./bpjs.png": 6136,
	"./btpn.png": 8078,
	"./bukalapak.png": 9202,
	"./dandan.png": 7988,
	"./hokben.png": 4981,
	"./kfc.png": 7898,
	"./kopikenangan.png": 9450,
	"./mandiri.png": 6324,
	"./maybank.png": 2626,
	"./ramayana.png": 6306,
	"./tixid.png": 7971,
	"./vidio.png": 7258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4936;